<script lang="ts" setup>
withDefaults(defineProps<{
  as?: any
  padding?: string
}>(), { padding: 'p-3', })
</script>

<template>
  <component
    :is="as ?? 'div'"
    class="bg-white rounded-v2md shadow-v2sm border-1 border-solid border-grey-primary text-navy"
    :class="padding"
  >
    <slot/>
  </component>
</template>
